import { Component, Input, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReservationCategory } from 'projects/qcloud-models/reservation-plugin/reservation-category';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { LocaleService } from '../../../services/locale.service';
import { TicketReservationService } from '../../../services/ticket-reservation.service';

@Component({
  selector: 'app-reservation-category-select',
  templateUrl: './reservation-category-select.component.html',
  styleUrls: ['./reservation-category-select.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReservationCategorySelectComponent implements OnInit {

  @Input() categories: ReservationCategory[];
  @Output() categoryChanged = new EventEmitter();
  selectedCategoryId: number;
  ticketReservation = new TicketReservationPlugin();

  constructor(private ticketReservationService: TicketReservationService, private localeService: LocaleService,
    private translate: TranslateService) {
    ticketReservationService.ticketReservation.subscribe((val: TicketReservationPlugin) => this.ticketReservation = val);
  }

  ngOnInit(): void {
    this.selectedCategoryId = this.categories[0].id;
    this.setCategoryId();
  }

  setCategoryId() {
    this.ticketReservation.categoryId = this.selectedCategoryId;
    this.ticketReservationService.updateTicketReservation(this.ticketReservation);
    this.categoryChanged.emit();
  }

  getCategoryName(category: ReservationCategory): string {
    let locale = this.translate.currentLang;
    if (this.localeService.getCategoryName(locale, category.id)) {
      return this.localeService.getCategoryName(locale, category.id);
    } else {
      return category.fullName;
    }
  }


}
